import React from 'react';
import { Console } from '../../../../tools';

const DevConsole = () => {
  const console = new Console({
    dev: true,
    name: 'Console',
  });

  const object = {
    key1: 'val1',
    key2: 'val2',
  };

  console.group('Group Info Code', () => {
    console.info('#p prev state', object);
    console.info('#a state', object);
    console.info('#n next state', object);
  });

  console.group('Group Info', () => {
    console.info('Data 1', object);
    console.info('Data 2', object);
  });

  console.log('This is string', 'A sample sentence');
  console.log('This is null', null);
  console.log('This is undefined', undefined);
  console.log('This is NaN', NaN);
  console.log('This is true', true);
  console.log('This is false', false);
  console.log('This is number', 1996);

  console.log('A sample sentence');
  console.log(null);
  console.log(undefined);
  console.log(NaN);
  console.log(true);
  console.log(false);
  console.log(1996);

  return (
    <div>
      <p>Please open the browser console.</p>
      <p>
        Press F12 to open it and right click on it and
        select &quot;Inspection&quot; from the options.
        In the panel that opens, open the &quot;Console&quot; tab.
      </p>
    </div>
  );
};

export default DevConsole;
